import { FORM_FIELDS } from '../../../../constants';
import { postMessage, PostMessageType } from '../../../../helpers/whitelable';
import {
    getAddressString,
    getStreetAndHouseFromAddress,
    removeZipCodeFromAddress,
    sourceValueByCode,
} from '../../../../helpers';
import { AREA_OF_EMPLOYMENT_SOURCE, EMPLOYER_TYPE_SOURCES } from '../../../../constants/sources';
import { getStore } from '../../../../store/client';

export interface CreateApplicationPostMessage {
    userId: string;
    locationRoute: string;
    sourceUrl?: string;
    deviceType?: string;
    amount: number;
    partnerId?: string;

    initialFee?: number;
    autoBrand?: string;
    autoBrandId?: string;
    autoModel?: string;
    autoModelId?: string;
    autoYear?: number;

    period: string;
    region: string;
    regionId: number;
    purpose: string;
    lastName: string;
    firstName: string;
    patronymic: string;
    email: string;
    phone: string;
    personalAgreementSigned: boolean;
    birthDate: string;
    birthPlace: string;
    gender?: string;

    passportSeriesNumber: string;
    passportIssuerCode: string;
    passportIssuedBy: string;
    passportIssueDate: string;

    registrationStreet: string;
    registrationHouse: string;
    registrationApartment?: string;
    registrationDate: string;
    registrationLocationRoute?: string;

    residenceSameRegistration?: boolean;
    residenceStreet?: string;
    residenceHouse?: string;
    residenceApartment?: string;
    residentialLocationRoute?: string;

    employmentType: string;
    unemploymentReason?: string;
    anotherUnemploymentReason?: string;
    monthlySalary: number;
    incomeConfirmation: string;
    organizationName?: string;
    employerINN?: string;
    employerType?: string;
    areaOfEmployment?: string;
    workAddress?: string;
    workPhone?: string;
    workLocationRoute?: string;
    jobType?: string;
    jobTitle?: string;
    lastExperienceStartMonth?: string;
    lastExperienceStartYear?: number;

    additionalPhone: string;
    additionalPhoneOwner: string;
    additionalPhoneOwnerFio: string;
    education: string;
    familyStatus: string;
    dependents?: string;
    additionalIncome?: number;
    ownCar?: string;
    ownProperty?: string;
    rentApartment?: number;
    snils?: string;
    creditSecurity?: string;

    pledgeRealtyAddressTheSame?: boolean;
    pledgeOwnerSingle?: boolean;
    pledgeAutoNumber?: string;
}

export const sendFullDataPostMessage = () => {
    postMessage({
        type: PostMessageType.event,
        label: 'broker_form_additional_submit',
    });

    const {
        region,
        userId = '',
        fbPayload: { device_type: deviceType = '', sourceUrl = '' } = {},
        formData,
    } = getStore().getState().formStore;

    const { street: registrationStreet, house: registrationHouse } = getStreetAndHouseFromAddress(
        formData[FORM_FIELDS.REGISTRATION_STREET],
    );

    const { street: residenceStreet, house: residenceHouse } = getStreetAndHouseFromAddress(
        formData[FORM_FIELDS.RESIDENCE_STREET],
    );

    const data: CreateApplicationPostMessage = {
        amount: Number(formData[FORM_FIELDS.AMOUNT]),
        initialFee: Number(formData[FORM_FIELDS.INITIAL_FEE]),
        autoBrand: formData[FORM_FIELDS.AUTO_BRAND] || undefined,
        autoBrandId: formData[FORM_FIELDS.AUTO_BRAND_ID] || undefined,
        autoModel: formData[FORM_FIELDS.AUTO_MODEL] || undefined,
        autoModelId: formData[FORM_FIELDS.AUTO_MODEL_ID] || undefined,
        autoYear: Number(formData[FORM_FIELDS.AUTO_YEAR]) || undefined,
        period: formData[FORM_FIELDS.PERIOD],
        region: formData[FORM_FIELDS.REGION],
        regionId: Number(formData[FORM_FIELDS.REGION_ID]),
        purpose: formData[FORM_FIELDS.PURPOSE],
        firstName: formData[FORM_FIELDS.FIRST_NAME],
        lastName: formData[FORM_FIELDS.LAST_NAME],
        patronymic: formData[FORM_FIELDS.MIDDLE_NAME],
        gender: formData[FORM_FIELDS.GENDER] || undefined,
        email: formData[FORM_FIELDS.EMAIL],
        phone: formData[FORM_FIELDS.PHONE],
        personalAgreementSigned: formData[FORM_FIELDS.AGREEMENT],
        birthDate: formData[FORM_FIELDS.BIRTHDAY],
        birthPlace: formData[FORM_FIELDS.BIRTH_PLACE],
        passportIssueDate: formData[FORM_FIELDS.PASSPORT_DATE],
        passportSeriesNumber: formData[FORM_FIELDS.PASSPORT_NUMBER],
        passportIssuerCode: formData[FORM_FIELDS.UNIT_CODE],
        passportIssuedBy: formData[FORM_FIELDS.ISSUED],
        registrationStreet,
        /** @deprecated */
        registrationHouse,
        registrationApartment: formData[FORM_FIELDS.REGISTRATION_APARTMENT],
        registrationDate: formData[FORM_FIELDS.REGISTRATION_DATE],
        registrationLocationRoute: formData[FORM_FIELDS.REGISTRATION_ROUTE],
        residenceSameRegistration: formData[FORM_FIELDS.RESIDENCE_SAME_REGISTRATION],
        residenceStreet,
        /** @deprecated */
        residenceHouse,
        residenceApartment: formData[FORM_FIELDS.RESIDENCE_APARTMENT],
        residentialLocationRoute: formData[FORM_FIELDS.RESIDENCE_ROUTE],
        employerType: formData[FORM_FIELDS.EMPLOYER_TYPE],
        organizationName: formData[FORM_FIELDS.ORGANIZATION_NAME],
        employerINN: formData[FORM_FIELDS.EMPLOYER_INN],
        employmentType: formData[FORM_FIELDS.EMPLOYMENT_TYPE],
        areaOfEmployment: formData[FORM_FIELDS.AREA_OF_EMPLOYMENT],
        lastExperienceStartMonth: formData[FORM_FIELDS.LAST_EXPERIENCE_START_MONTH],
        lastExperienceStartYear: Number(formData[FORM_FIELDS.LAST_EXPERIENCE_START_YEAR]),
        jobTitle: formData[FORM_FIELDS.JOB_TITLE],
        jobType: formData[FORM_FIELDS.JOB_TYPE] || undefined,
        workAddress: formData[FORM_FIELDS.WORK_ADDRESS],
        workLocationRoute: formData[FORM_FIELDS.WORK_ROUTE],
        workPhone: formData[FORM_FIELDS.WORK_PHONE],
        monthlySalary: Number(formData[FORM_FIELDS.MONTHLY_SALARY]),
        incomeConfirmation: formData[FORM_FIELDS.INCOME_CONFIRMATION],
        additionalPhone: formData[FORM_FIELDS.ADDITIONAL_PHONE],
        additionalPhoneOwner: formData[FORM_FIELDS.ADDITIONAL_PHONE_OWNER] || '',
        additionalPhoneOwnerFio: formData[FORM_FIELDS.ADDITIONAL_PHONE_OWNER_FIO],
        education: formData[FORM_FIELDS.EDUCATION],
        familyStatus: formData[FORM_FIELDS.FAMILY_STATUS],
        dependents: formData[FORM_FIELDS.NUMBER_OF_DEPENDENTS] || undefined,
        additionalIncome: Number(formData[FORM_FIELDS.ADDITIONAL_INCOME]),
        ownCar: formData[FORM_FIELDS.CAR] || undefined,
        ownProperty: formData[FORM_FIELDS.PROPERTY_TYPE] || undefined,
        rentApartment: Number(formData[FORM_FIELDS.RENT_APARTMENT]),
        snils: formData[FORM_FIELDS.SNILS],
        creditSecurity: formData[FORM_FIELDS.CREDIT_SECURITY] || undefined,
        pledgeRealtyAddressTheSame: formData[FORM_FIELDS.PLEDGE_REALTY_ADDRESS_THE_SAME],
        pledgeAutoNumber: formData[FORM_FIELDS.PLEDGE_AUTO_NUMBER] || undefined,
        pledgeOwnerSingle: formData[FORM_FIELDS.PLEDGE_OWNER_SINGLE],
        unemploymentReason: formData[FORM_FIELDS.UNEMPLOYMENT_REASON] || undefined,
        anotherUnemploymentReason: formData[FORM_FIELDS.ANOTHER_UNEMPLOYMENT_REASON],
        partnerId: formData[FORM_FIELDS.PARTNER_ID],

        sourceUrl,
        deviceType,
        userId,
        locationRoute: (region && region.name === formData[FORM_FIELDS.REGION] && region.route) || '6.',
    };

    postMessage({ application: data });
};

/** Проверяет список AREA_OF_EMPLOYMENT_SOURCE и находит значение, в соответствии с ОКВЭД */
export const findAreaOfEmploymentByOkved = (okved: string) => {
    if (!okved) {
        return;
    }
    const sources = AREA_OF_EMPLOYMENT_SOURCE;
    const result = sources.find(({ okved: okvedRange = '' }) => {
        const ranges = okvedRange.split(/\s*,\s*/).map((item) => item.split(/\s*-\s*/));
        return ranges.some(([from, to]) =>
            to === undefined
                ? /** для конкретных значений */
                  okved.indexOf(from) === 0
                : /** для диапазонов */
                  okved >= from && okved <= `${to}999`,
        );
    });

    return result || sources.find(({ value }) => value === 'Other');
};

export const getProperOrganizationName = (names: Array<string>) => {
    const sorted = names.slice().sort((a, b) => ((a || '').length - (b || '').length <= 0 ? 1 : -1));
    return sorted.find((item) => item.length <= 255) || (sorted.pop() || '').slice(0, 255);
};

export const organizationDataToForm = (organization: Dadata.OrganizationSuggestItem) => {
    const { formData } = getStore().getState().formStore;

    const {
        value,
        data: {
            opf,
            inn,
            address,
            okved,
            phones,
            name: { short: shortOrgName },
        },
    } = organization || { data: {} };

    const {
        [FORM_FIELDS.ORGANIZATION_NAME]: organizationNameInForm,
        [FORM_FIELDS.EMPLOYER_TYPE]: employerTypeInForm,
        [FORM_FIELDS.EMPLOYER_INN]: innInForm,
        [FORM_FIELDS.WORK_ADDRESS]: addressInForm,
        [FORM_FIELDS.OKVED]: okvedInForm,
        [FORM_FIELDS.WORK_PHONE]: phoneInForm,
    } = formData;

    const areaOfEmployment = okved && findAreaOfEmploymentByOkved(okved);
    const { code: opfCode } = opf || {};
    const { value: suggestAddress, data: addressData } = address || {};
    let addressValue = suggestAddress;

    const fullName = formData[FORM_FIELDS.FULL_NAME];

    if (opfCode === '50102' && value.includes(fullName)) {
        /** Для ИП, кто работает сам на себя, подставляем адрес регистрации в рабочий адрес */
        const { [FORM_FIELDS.REGISTRATION_STREET]: street, [FORM_FIELDS.REGISTRATION_APARTMENT]: apartment } = formData;
        addressValue = (street && getAddressString(street, apartment)) || addressValue;
    }
    const opfValue = sourceValueByCode(opfCode, EMPLOYER_TYPE_SOURCES);

    addressValue = removeZipCodeFromAddress(addressValue);

    const minOrganizationName = getProperOrganizationName([value, shortOrgName]);

    const dataToUpdate: FE.FormData = {
        [FORM_FIELDS.ORGANIZATION_NAME]: minOrganizationName || organizationNameInForm,
        [FORM_FIELDS.EMPLOYER_TYPE]: opfValue || employerTypeInForm,
        [FORM_FIELDS.EMPLOYER_INN]: inn || innInForm,
        [FORM_FIELDS.WORK_ADDRESS]: addressValue || addressInForm,
        [FORM_FIELDS.OKVED]: okved || okvedInForm,
    };

    if (areaOfEmployment) {
        dataToUpdate[FORM_FIELDS.AREA_OF_EMPLOYMENT] = areaOfEmployment.value;
    }

    if (!phoneInForm && phones && phones.length) {
        const phone = phones.reduce((correctNumber: string, currentPhone: { value: string }) => {
            if (correctNumber) {
                return correctNumber;
            }
            const currentValue = currentPhone.value || '';
            const trying = currentValue.split(',')[0].replace(/\D/g, '');
            if (trying.length >= 10) {
                return trying;
            }
        }, '');

        dataToUpdate[FORM_FIELDS.WORK_PHONE] = phone ? `+7${phone.substr(-10)}` : '';
    }

    return dataToUpdate;
};
